import { Typography } from "antd";


export default function CardIconCustom ({ text, extra }: { text: string; extra?: React.ReactNode }) {
    return (
        <div style={{ 
            width: '100%', 
            height: '85px', 
            borderRadius: '8px', 
            background: 'linear-gradient(90deg, rgba(10,146,240,1) 0%, rgba(10,4,168,1) 39%, rgba(10,4,168,1) 65%, rgba(10,146,240,1) 100%)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0 32px',
            }}
        >
            <Typography style={{ 
                fontSize: '32px', 
                color: 'white', 
                textAlign: 'left', 
                margin: '0 32px 0 0' }}
                title={text}
            >
                {text.length > 60? `${text.slice(0,60)}...`: text}
            </Typography>
            {extra && <div style={{ marginLeft: '32px' }}>{extra}</div>}
        </div>
    )
}